import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "variant"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo } from 'react';
import { Badge as FlowBiteBadge } from 'flowbite-react';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
export var Badge = function Badge(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  var renderEl = useMemo(function () {
    if (variant === 'primary') return /*#__PURE__*/_jsx(Primary, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'tertiary') return /*#__PURE__*/_jsx(Tertiary, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'error') return /*#__PURE__*/_jsx(Error, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'success') return /*#__PURE__*/_jsx(Success, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'info') return /*#__PURE__*/_jsx(Info, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'disabled') return /*#__PURE__*/_jsx(Disabled, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'warning') return /*#__PURE__*/_jsx(Warning, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'danger') return /*#__PURE__*/_jsx(Danger, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'fresh') return /*#__PURE__*/_jsx(Fresh, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'neutral') return /*#__PURE__*/_jsx(Neutral, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
    if (variant === 'restworld') return /*#__PURE__*/_jsx(Restworld, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));else return /*#__PURE__*/_jsx(Secondary, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
  }, [children, rest, variant]);
  return renderEl;
};
export default Badge;
var baseBadgeStyles = {
  "height": "24px",
  "borderRadius": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "fontSize": "14px"
};
var newBadgeStyles = {
  "minWidth": "fit-content",
  "borderRadius": "0.25rem",
  "fontWeight": "500"
};

var Primary = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Primary",
  componentId: "sc-148lrr0-0"
})(["", ";", ";"], baseBadgeStyles, {
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(156 163 175 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
});

var Secondary = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Secondary",
  componentId: "sc-148lrr0-1"
})(["", ";", ";"], baseBadgeStyles, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))"
});

var Tertiary = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Tertiary",
  componentId: "sc-148lrr0-2"
})(["", ";", ";"], baseBadgeStyles, {
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});

var Error = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Error",
  componentId: "sc-148lrr0-3"
})(["", ";", ";"], baseBadgeStyles, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(239 176 186 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(145 0 24 / var(--tw-text-opacity))"
});

var Success = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Success",
  componentId: "sc-148lrr0-4"
})(["", ";", ";"], baseBadgeStyles, {
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(230 241 236 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(0 84 45 / var(--tw-text-opacity))"
});

var Info = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Info",
  componentId: "sc-148lrr0-5"
})(["", ";", ";"], [baseBadgeStyles, newBadgeStyles], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))"
});

var Disabled = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Disabled",
  componentId: "sc-148lrr0-6"
})(["", ";", ""], [baseBadgeStyles, newBadgeStyles], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var Warning = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Warning",
  componentId: "sc-148lrr0-7"
})(["", ";", ""], [baseBadgeStyles, newBadgeStyles], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(252 241 230 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(158 84 0 / var(--tw-text-opacity))"
});

var Danger = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Danger",
  componentId: "sc-148lrr0-8"
})(["", ";", ""], [baseBadgeStyles, newBadgeStyles], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(145 0 24 / var(--tw-text-opacity))"
});

var Fresh = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Fresh",
  componentId: "sc-148lrr0-9"
})(["", ";", ""], [baseBadgeStyles, newBadgeStyles], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(250 250 250 / var(--tw-text-opacity))"
});

var Neutral = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Neutral",
  componentId: "sc-148lrr0-10"
})(["", ";", ""], [baseBadgeStyles, newBadgeStyles], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var Restworld = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(FlowBiteBadge, _objectSpread({}, props));
}).withConfig({
  displayName: "badge__Restworld",
  componentId: "sc-148lrr0-11"
})(["", ";", ""], [baseBadgeStyles, newBadgeStyles], {
  "width": "fit-content",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(72 36 133 / var(--tw-text-opacity))"
});